import React from 'react'
import DmtCommision from '../../../components/dmtModule/dmtCommision/DmtCommision'

function DmtCommisionp() {
  return (
    <div><DmtCommision/></div>
  )
}

export default DmtCommisionp